import { Mail, Phone, MessageCircle } from "lucide-react";
import { LeadForm } from "@/components/site/LeadForm";
import { useProgrammes } from "@/hooks/useProgrammes";
import { CONTACT, waLink } from "@/lib/api";

const CHANNELS = [
  { id: "phone", icon: Phone, label: "Téléphone", value: CONTACT.phone, href: `tel:${CONTACT.tel}` },
  { id: "whatsapp", icon: MessageCircle, label: "WhatsApp", value: CONTACT.phone, href: waLink(), external: true },
  { id: "email", icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}` },
];

export default function Contact() {
  const { data } = useProgrammes();
  return (
    <div className="bg-[#1A1716] text-white relative grain min-h-[80vh]" data-testid="contact-page">
      <div className="relative max-w-7xl mx-auto px-5 lg:px-10 py-20 md:py-28 grid lg:grid-cols-12 gap-16">
        <div className="lg:col-span-5">
          <p className="eyebrow">Contact</p>
          <h1 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl mt-4 leading-tight">Parlons de votre projet</h1>
          <p className="text-white/60 mt-6 max-w-md">Demande d'information, de visite ou de réservation : notre équipe vous répond rapidement.</p>
          <div className="mt-12 space-y-4">
            {CHANNELS.map(({ id, icon: Icon, label, value, href, external }) => (
              <a key={id} href={href} target={external ? "_blank" : undefined} rel="noreferrer" data-testid={`contact-channel-${id}`}
                className="flex items-center gap-5 p-5 border border-white/10 rounded-sm hover:border-[#C88A58] hover:bg-white/5 transition-colors duration-300">
                <span className="h-11 w-11 rounded-full bg-[#C88A58]/15 grid place-items-center"><Icon className="h-5 w-5 text-[#D4A373]" /></span>
                <span>
                  <span className="block text-xs uppercase tracking-[0.2em] text-white/50">{label}</span>
                  <span className="block mt-1">{value}</span>
                </span>
              </a>
            ))}
          </div>
        </div>
        <div className="lg:col-span-7 bg-white/[0.03] border border-white/10 p-6 sm:p-10 rounded-sm backdrop-blur-xl">
          <LeadForm programmes={data} dark />
        </div>
      </div>
    </div>
  );
}
